import "./AuthCallback.css";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { setToken } from "../../api/client";
import { useAuth } from "../../auth/AuthContext";
import Button from "../../components/Button/Button";
import Loader from "../../components/Loader/Loader";

const REASONS = {
  not_whitelisted:
    "This Google account is not on the mentor/admin roster. Ask an organiser to grant access.",
  registration_number_claimed:
    "The registration number in this account's Google name is already linked to a different Google account.",
  blacklisted: "This account has been removed.",
  server_error:
    "Something went wrong on our side while signing you in. Try again in a moment.",
};

export default function AuthCallback() {
  const navigate = useNavigate();
  const { refreshMe } = useAuth();
  const [failure, setFailure] = useState(null);

  const handoff = useRef(null);
  if (handoff.current === null) {
    const params = new URLSearchParams(window.location.search);
    handoff.current = {
      token: params.get("token"),
      error: params.get("error"),
    };
  }

  useEffect(() => {
    const { token, error } = handoff.current;

    if (token) {
      setToken(token);
      window.history.replaceState({}, "", "/");
      refreshMe().then(() => navigate("/", { replace: true }));
      return;
    }

    setFailure(error || "server_error");
  }, [navigate, refreshMe]);

  if (!failure) return <Loader />;

  return (
    <div className="auth-callback col">
      <div className="auth-callback-card col">
        <span className="t-eyebrow t-brand">Multipli Hackathon</span>
        <h1 className="t-h1">We couldn't sign you in</h1>
        <p className="t-body t-dim">{REASONS[failure] || REASONS.server_error}</p>
        <Button block onClick={() => navigate("/", { replace: true })}>
          Back to sign in
        </Button>
      </div>
    </div>
  );
}
